import { io } from "socket.io-client";
import { getSocketBaseUrl } from "./utils/socketBaseUrl";

/**
 * Creates an authenticated Socket.IO connection to a named namespace.
 * Passes the access token as a query parameter for server-side auth.
 *
 * Returns null when there is no access token: the server rejects an
 * unauthenticated handshake, and socket.io would otherwise retry it forever.
 * Callers must handle a null return.
 *
 * @param {string} route - The socket namespace/route (e.g. "bunmail")
 * @returns {Socket|null} The socket instance, or null when unauthenticated
 */
const socketIoConnection = (route) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return null;

  const path =
    process.env.NODE_ENV === "production" ? "/api/socket.io" : "/socket.io";
  const baseUrl = getSocketBaseUrl();
  try {
    const socket = io(baseUrl, {
      query: { access_token: accessToken, route },
      transports: ["websocket"],
      path,
      reconnectionAttempts: 10,
      reconnectionDelayMax: 10000,
    });
    return socket;
  } catch (error) {
    return null;
  }
};

export default socketIoConnection;
